import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img22 from "../../About/images/22.jpg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person22 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img22} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Кислов Александр Петрович
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Кандидат технических наук, профессор
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=7006212019'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-4816-8008'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        НАО «Торайгыров Университет», старший научный сотрудник
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Старший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на основных стационарных источниках эмиссий ответственным в области охраны окружающей среды с использованием облачных технологий или промышленного интернета вещей.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участник был подобран с учетом его опыта участия в предыдущих научных проектах, публикационной активности и производственного стажа. Компетенции включают:
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проведение анализа научной литературы по теме исследования;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Подготовка статей к публикации;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка плана экспериментов;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Проведение опытных исследований по передаче данных по радиоканалу.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований, написание научных статей;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка методов передачи данных с первичных измерителей на основных стационарных источниках эмиссий ответственным в области охраны окружающей среды с использованием облачных технологий или промышленного интернета вещей.
                </MyText>
            </Flex>
        </Flex>
    );
}